import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  getSummary(params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/admin/summary", { params })
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getCompanies($, params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/admin/companies", params)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getCompanyVehicles($, id, params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/admin/companies/${id}/vehicles`, {
        params
      })
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getCompanyUsers($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/admin/companies/${id}/connections`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getPendingInvitations($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/admin/companies/${id}/pending_invitations`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getExtendPlan($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`payments/extend_period/${id}`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  inviteMember($, id, invitees) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/account/admin/companies/${id}/invite`, invitees)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  inviteUserToCompany($, id, email) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/account/admin/companies/${id}/invite-admin`,  {
        email: email
      })
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },

  importCompanyVehicles($, companyId, formData) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/vehicle/${companyId}/import`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(() => {
          $.$store.commit("app/message", {
            msg: $.$t("messages.success.import"),
            color: "success"
          });
        })
        .catch((error) => {
          let message = ""
          if (error.response && error.response.data) {
            for (const key in error.response.data) {
              message += `- ${key} : ${error.response.data[key]}\n`
            }
          } else {
            message = "Erreur lors de l'importation"
          }

          $.$store.commit("app/message", {
            msg: message,
            color: "error"
          });
        });
    })
  },

  importCompanyVouchers($, companyId, formData) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/voucher/${companyId}/import`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          $.$store.commit("app/message", {
            msg: $.$t("messages.success.import") || "Importation des bons réussie.",
            color: "success",
          })
          resolve(response.data)
        })
        .catch((error) => {
          let message = ""
          if (error.response && error.response.data) {
            for (const key in error.response.data) {
              message += `- ${key} : ${JSON.stringify(error.response.data[key])}\n`
            }
          } else {
            message = "Erreur lors de l'importation des bons"
          }

          $.$store.commit("app/message", {
            msg: message,
            color: "error",
          })
          reject(error)
        })
    })
  },


  /**
   * Enables to update the status of the selected company
   * @param {*} $
   * @param {*} id company's id
   * @param {*} data which contains {is_active: true/false}
   * @returns list of the users updated
   */
  updateCompanyStatus($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/admin/companies/${id}/status`, data)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  /**
   * Enables to update the status of the selected company
   * @param {*} $
   * @param {*} id user's id
   * @param {*} data which contains {is_active: true/false}
   * @returns the user updated
   */
  updateUserStatus($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/admin/user/${id}/status`, data)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  /**
   *
   * @param {*} $
   * @returns list of users that hasnt been validated by the admin
   */
  getPendingValidations($, params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/admin/validations", { params })
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  validateUser($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/admin/validations/${id}`, data)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },

  async getCompanyById(companyId) {
    const { data } = await HTTP.get(`/account/admin/companies/${companyId}`)
    return data
  },
  async updateCompany(companyId, payload) {
    // payload: { name, company_avalanche_id, ceiling, can_served, company_type }
    const { data } = await HTTP.patch(`/account/admin/companies/${companyId}`, payload)
    return data
  },

  getUsers($, params = {}) {
    return HTTP.get("/account/admin/users", { params })
      .then(r => r.data)
  },
  updateUser($, id, payload) {
    return HTTP.patch(`/account/admin/user/${id}`, payload)
      .then(r => r.data)
      .catch(error => { new EHC(DEFAULTS_HANDLERS).intercept(error); throw error })
  },

  regenerateUserPassword($, id) {
    return HTTP.post(`/account/admin/user/${id}/regenerate-password`)
      .then(r => r.data)
      .catch(error => { new EHC(DEFAULTS_HANDLERS).intercept(error); throw error })
  },

  getVehicles($, params = {}) {
    return HTTP.get("/account/admin/vehicles", { params })
      .then(r => r.data)
  },

  updateVehicle($, id, payload) {
    return HTTP.patch(`/account/admin/vehicle/${id}`, payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  createVehicle($, payload) {
    return HTTP.post("/account/admin/vehicle/create", payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  getCompanyDepartments($, companyId) {
    return HTTP.get(`/account/company/${companyId}/departments`)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  updateVehicleStatus($, id, data) {
    // { is_blocked: true/false } ou { is_activated: true/false } ou les deux
    return HTTP.patch(`/account/admin/vehicle/${id}/status`, data)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },


  getActivities($, params = {}) {
    return HTTP.get("/activity/admin/histories", { params }).then(r => r.data)
  },
  // Création d'une activité (paiement)
  createPayment($, payload) {
    // payload: { activity_uuid, product, quantity, amount, image, ... }
    return HTTP.post("/activity/make/payment", payload).then(r => r.data)
  },

  // Demandes de régularisation / annulation
  getActivityAdjustments($, params = {}) {
    return HTTP.get("/activity/admin/activity-adjustments", { params }).then(r => r.data)
  },
  getActivityAdjustmentDetail($, id) {
    return HTTP.get(`/activity/admin/activity-adjustments/${id}`).then(r => r.data)
  },
  createActivityAdjustment($, payload) {
    // payload: { activity, action: 'cancel'|'modify', reason, new_amount?, new_quantity?, new_product? }
    return HTTP.post("/activity/admin/activity-adjustments", payload).then(r => r.data)
  },
  approveActivityAdjustment($, id) {
    return HTTP.post(`/activity/admin/activity-adjustments/${id}/approve`).then(r => r.data)
  },
  rejectActivityAdjustment($, id) {
    return HTTP.post(`/activity/admin/activity-adjustments/${id}/reject`).then(r => r.data)
  },

  async listBusinessCompanies($, { withProducts = true } = {}) {
    const params = { company_type: "Business" }
    if (withProducts) params.with_products = true
    const { data } = await HTTP.get("/account/companies", { params })
    return data
  },

  // Facultatif: si tu préfères charger une seule société
  async getCompanyWithProducts($, companyId) {
    const { data } = await HTTP.get(`/account/companies/${companyId}`, { params: { with_products: true } })
    return data
  },

// ========================================
  // NOUVELLES MÉTHODES - CRÉATION MANUELLE
  // ========================================

  /**
   * Recherche de véhicules pour la modal de création manuelle
   * @param {Object} $ - Contexte Vue (this)
   * @param {Object} params - { q: string, company_id?: number }
   * @returns {Promise<Array>} Liste des véhicules correspondants
   */
  searchVehicles($, params = {}) {
    return HTTP.get("/activity/admin/vehicles-search", { params })
      .then(r => r.data)
      .catch(e => {
        console.error("Erreur recherche véhicules:", e)
        return []
      })
  },

  /**
   * Création manuelle d'une activité (transaction) par un administrateur
   * Permet de spécifier la date de création et d'autres paramètres
   * 
   * @param {Object} $ - Contexte Vue (this)
   * @param {Object} payload - Données de la transaction
   * @param {string} [payload.vehicle_id] - ID du véhicule (UUID)
   * @param {number} [payload.user_id] - ID de l'utilisateur (si pas de véhicule)
   * @param {number} payload.product_id - ID du produit
   * @param {number} payload.quantity - Quantité en litres
   * @param {number} payload.amount - Montant en XOF
   * @param {number} [payload.shop_id] - ID de la station
   * @param {number} [payload.kmh] - Kilométrage
   * @param {string} [payload.image] - Image pompe en base64
   * @param {string} [payload.vehicle_image] - Image véhicule en base64
   * @param {string} [payload.created_at] - Date/heure ISO (optionnel)
   * @param {boolean} [payload.debit_voucher=true] - Débiter le bon actif
   * @param {boolean} [payload.award_points=false] - Attribuer des points
   * @param {string} [payload.description] - Description/note
   * @returns {Promise<Object>} Activité créée
   */
  createActivityManual($, payload) {
    return HTTP.post("/activity/admin/manual-create", payload)
      .then(r => r.data)
      .catch(e => {
        // Propager l'erreur pour affichage dans le composant
        throw e
      })
  },

  /**
   * Alternative: Création via l'endpoint existant avec flag manuel
   * Utiliser si vous préférez étendre l'API existante plutôt qu'en créer une nouvelle
   */
  createActivityManualAlt($, payload) {
    // Ajoute un flag pour indiquer une création manuelle
    const data = {
      ...payload,
      is_manual_creation: true,
    }
    return HTTP.post("/activity/admin/histories", data)
      .then(r => r.data)
      .catch(e => {
        throw e
      })
  },

  /**
   * Récupérer les détails d'un véhicule avec ses bons actifs
   * Utile pour afficher les informations dans la modal de création
   */
  getVehicleDetails($, vehicleId) {
    return HTTP.get(`/account/admin/vehicle/${vehicleId}`, {
      params: { include_vouchers: true }
    })
      .then(r => r.data)
      .catch(e => {
        throw e
      })
  },

  /**
   * Récupérer la liste des produits d'une entreprise
   */
  getCompanyProducts($, companyId) {
    return HTTP.get(`/business/products`, {
      params: { company: companyId }
    })
      .then(r => r.data)
      .catch(e => {
        console.error("Erreur chargement produits:", e)
        return []
      })
  },

  getCompanyShops($, companyId) {
    return HTTP.get(`/business/shops`, {
      params: { company: companyId }
    })
      .then(r => r.data)
      .catch(e => {
        console.error("Erreur chargement stations:", e)
        return []
      })
  },

  // Tarif preferentiel d'un utilisateur fidelite (par societe)
  getUserCustomRates($, userId) {
    return HTTP.get(`/account/admin/user/${userId}/custom-rates`)
      .then(r => r.data)
  },

  updateUserCustomRate($, userId, payload) {
    return HTTP.patch(`/account/admin/user/${userId}/custom-rates`, payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  /**
   * Récupérer les statistiques d'activités pour le dashboard
   */
  getActivityStats($, params = {}) {
    return HTTP.get("/activity/admin/stats", { params })
      .then(r => r.data)
      .catch(e => {
        console.error("Erreur stats activités:", e)
        return null
      })
  },

  // Crédits carburant
  getVouchers($, params = {}) {
    return HTTP.get("/activity/admin/vouchers", { params }).then(r => r.data)
  },

  createVoucher($, payload) {
    return HTTP.post("/account/admin/voucher/create", payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },
  
  getVouchersStats($, params = {}) {
    return HTTP.get("/activity/admin/vouchers/stats", { params }).then(r => r.data).catch(() => ({}))
  },
  
  getVoucherDetail($, id) {
    return HTTP.get(`/activity/admin/vouchers/${id}`).then(r => r.data)
  },
  
  updateVoucher($, id, payload) {
    return HTTP.patch(`/activity/admin/vouchers/${id}/update`, payload).then(r => r.data)
  },
  
  toggleVoucherActivation($, id, isActivated = undefined) {
    const payload = isActivated !== undefined ? { is_activated: isActivated } : {}
    return HTTP.post(`/activity/admin/vouchers/${id}/toggle-activation`, payload).then(r => r.data)
  },
  
  bulkVoucherAction($, payload) {
    return HTTP.post("/activity/admin/vouchers/bulk-action", payload).then(r => r.data)
  },


/**
 * Active ou désactive can_take_picture pour tous les véhicules d'une société
 * @param {Object} $ - Contexte Vue (this)
 * @param {number|string} companyId - ID de la société
 * @param {boolean} canTakePicture - true pour activer, false pour désactiver
 * @returns {Promise<Object>} { updated_count, can_take_picture, message }
 */
bulkToggleCanTakePicture($, companyId, canTakePicture) {
  return HTTP.post(`/business/companies/${companyId}/vehicles/bulk-can-take-picture`, {
    can_take_picture: canTakePicture
  })
    .then(r => {
      $.$store.commit("app/message", {
        msg: r.data.message,
        color: "success"
      })
      return r.data
    })
    .catch(e => {
      $.$store.commit("app/message", {
        msg: "Erreur lors de la mise à jour",
        color: "error"
      })
      throw e
    })
},

/**
 * Récupère les stats can_take_picture pour une société
 */
getCanTakePictureStats($, companyId) {
  return HTTP.get(`/business/companies/${companyId}/vehicles/bulk-can-take-picture`)
    .then(r => r.data)
    .catch(() => null)
},

triggerOCR($, activityId, engine = null) {
  const data = engine ? { engine } : {}
  return HTTP.post(`/activity/admin/activities/${activityId}/trigger-ocr`, data)
    .then(r => r.data)
},

triggerPlateOCR($, activityId, engine = null) {
  const data = engine ? { engine } : {}
  return HTTP.post(`/activity/admin/activities/${activityId}/trigger-plate-ocr`, data)
    .then(r => r.data)
},

  // ================= Dons (admin, toutes companies) =================
  getDonations($, params = {}) {
    return HTTP.get("/business/admin/donations", { params }).then(r => r.data)
  },

  getDonation($, id) {
    return HTTP.get(`/business/admin/donations/${id}`).then(r => r.data)
  },

  updateDonation($, id, payload) {
    return HTTP.patch(`/business/admin/donations/${id}`, payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  deleteDonation($, id) {
    return HTTP.delete(`/business/admin/donations/${id}`)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  toggleDonationBlock($, id, isBlocked = undefined) {
    const payload = isBlocked !== undefined ? { is_blocked: isBlocked } : {}
    return HTTP.post(`/business/admin/donations/${id}/toggle-block`, payload)
      .then(r => r.data)
      .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e })
  },

  getDonationBadge($, id) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/business/donations/${id}/badge`
      const xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = () => {
        if (xhr.status === 200) resolve(URL.createObjectURL(xhr.response))
        else reject(xhr)
      }
      xhr.onerror = () => reject(xhr)
      xhr.send()
    })
  },
}